/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import { post, CashRequestOptions } from '@cash-web/shared-util-fetch'
import {SetVerticalTypeEnablementRequest} from '@cash-web/protos/squareup/cash/local/v1/seller/cash_app_local_seller_service.pb'
import {SetVerticalTypeEnablementResponse} from '@cash-web/protos/squareup/cash/local/v1/seller/cash_app_local_seller_service.pb'


export const setVerticalTypeEnablement = (request: SetVerticalTypeEnablementRequest, options?: CashRequestOptions) => post<SetVerticalTypeEnablementRequest, SetVerticalTypeEnablementResponse>("/2.0/cash/set-vertical-type-enablement", request, {...options, rejectOnError: true })